import { index, pgTable, text, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import z from "zod";

import { clinicsTable } from "./clinicsSchema";
import { customTimestamp } from "./utils/types";

export const clinicProvidersTable = pgTable(
  "clinic_providers",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    clinicId: uuid("clinic_id")
      .references(() => clinicsTable.id, { onDelete: "cascade" })
      .notNull(),
    firstName: text("first_name").notNull(),
    lastName: text("last_name").notNull(),
    // Free text rather than an enum: the credential set is open-ended and
    // sourced from an external spreadsheet, so new values must not require a migration.
    credential: text("credential").notNull(),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [index("clinic_providers_clinic_id_index").on(table.clinicId)],
);

export const clinicProviderSchema = createSelectSchema(clinicProvidersTable);
export type ClinicProviderType = z.infer<typeof clinicProviderSchema>;

export const insertClinicProviderSchema = createInsertSchema(
  clinicProvidersTable,
  {
    clinicId: z.uuid().min(1),
    firstName: z.string().trim().min(1),
    lastName: z.string().trim().min(1),
    credential: z.string().trim().min(1),
  },
).omit({
  createdAt: true,
  updatedAt: true,
});

export type InsertClinicProviderType = z.infer<
  typeof insertClinicProviderSchema
>;
